import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PersonIcon from "@mui/icons-material/Person";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import FactoryIcon from "@mui/icons-material/Factory";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { formatBroadSectorLabel } from "../../features/bre/companies/BRECompanyHelpers";

import PaidIcon from "@mui/icons-material/Paid";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import GroupsIcon from "@mui/icons-material/Groups";

import SquareFootIcon from "@mui/icons-material/SquareFoot";
import ApartmentIcon from "@mui/icons-material/Apartment";
import DomainIcon from "@mui/icons-material/Domain";

import ChecklistIcon from "@mui/icons-material/Checklist";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import { BRAND_GREEN } from "../../theme/colors";

import { PROJECT_TYPES } from "../../features/projects/ProjectTypes";

/*
-------------------------------------------------------
FORMAT HELPERS
-------------------------------------------------------
*/

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null;

const currency = (val) =>
  val != null && val !== "" ? `$${Number(val).toLocaleString()}` : null;

const formatValue = (v) => {
  if (Array.isArray(v)) return v.length ? v.join(", ") : null;
  if (v === "" || v === null || v === undefined) return null;
  return v;
};

const cleanRows = (rows) =>
  rows
    .map((r) => ({
      ...r,
      value: formatValue(r.value),
    }))
    .filter((r) => r.value !== null);

/*
-------------------------------------------------------
PROFILE CONFIG
-------------------------------------------------------
*/

export function projectProfileConfig(project = {}) {
  return [
    {
      title: "Overview",
      rows: cleanRows([
        {
          icon: <BusinessCenterIcon />,
          iconColor: BRAND_GREEN,
          label: "Project Type",
          value:
            PROJECT_TYPES.find((t) => t.value === project.project_type)
              ?.label || project.project_type,
        },
        {
          icon: <PersonIcon />,
          iconColor: BRAND_GREEN,
          label: "Project Manager",
          value: project.project_manager,
        },
        {
          icon: <EventIcon />,
          iconColor: BRAND_GREEN,
          label: "Start Date",
          value: formatDate(project.start_date),
        },
        {
          icon: <LocationOnIcon />,
          iconColor: BRAND_GREEN,
          label: "Location",
          value: [project.city, project.state].filter(Boolean).join(", "),
        },
      ]),
    },

    {
      title: "Industry & Workforce",
      rows: cleanRows([
        {
          icon: <FactoryIcon />,
          iconColor: BRAND_GREEN,
          label: "Sector",
          value: formatBroadSectorLabel(project.sector),
        },
        {
          icon: <PrecisionManufacturingIcon />,
          iconColor: BRAND_GREEN,
          label: "NAICS Text",
          value: project.naics_text,
        },
        {
          icon: <PrecisionManufacturingIcon />,
          iconColor: BRAND_GREEN,
          label: "NAICS Code",
          value: project.naics_code,
        },
        {
          icon: <PrecisionManufacturingIcon />,
          iconColor: BRAND_GREEN,
          label: "Custom Industry",
          value: project.industry_custom || (project.naics_text ? null : project.industry),
        },
        {
          icon: <EngineeringIcon />,
          iconColor: BRAND_GREEN,
          label: "Skill Sets",
          value: project.skill_sets,
        },
      ]),
    },

    {
      title: "Financials",
      rows: cleanRows([
        {
          icon: <PaidIcon />,
          iconColor: BRAND_GREEN,
          label: "Investment",
          value: currency(project.investment_amount),
        },
        {
          icon: <GroupsIcon />,
          iconColor: BRAND_GREEN,
          label: "Jobs Created",
          value: project.jobs_created,
        },
        {
          icon: <AttachMoneyIcon />,
          iconColor: BRAND_GREEN,
          label: "Wage Rate",
          value: currency(project.wage_rate),
        },
      ]),
    },

    {
      title: "Site Details",
      rows: cleanRows([
        {
          icon: <ApartmentIcon />,
          iconColor: BRAND_GREEN,
          label: "Target Site",
          value: project.target_site,
        },
        {
          icon: <SquareFootIcon />,
          iconColor: BRAND_GREEN,
          label: "Square Footage",
          value: project.square_footage,
        },
        {
          icon: <ChecklistIcon />,
          iconColor: BRAND_GREEN,
          label: "Site Readiness",
          value: project.site_readiness,
        },
        {
          icon: <LocalShippingIcon />,
          iconColor: BRAND_GREEN,
          label: "Transportation",
          value: project.transportation_requirements,
        },
        {
          icon: <ElectricalServicesIcon />,
          iconColor: BRAND_GREEN,
          label: "Utilities",
          value: project.utility_requirements,
        },
        {
          icon: <ChecklistIcon />,
          iconColor: BRAND_GREEN,
          label: "Infrastructure",
          value: project.infrastructure_requirements,
        },
        {
          icon: <DomainIcon />,
          iconColor: BRAND_GREEN,
          label: "Property Owner",
          value: project.property_owner,
        },
      ]),
    },
  ].filter((section) => section.rows.length > 0);
}
